<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Arbeitszeitraster</span>
            <!--b-form-radio-group
                style="margin-left: auto;
                        margin-top: auto;
                         margin-bottom: auto;"
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-primary"
                buttons
            ></b-form-radio-group-->
            <v-btn
                block
                tile
                color="success"
                @click="selectedAzraId = ''; createAzraDialog = true;"
                style="height: 32px; width: 180px !important; max-width: 180px !important; min-width: 180px !important; margin-left: auto;
                    margin-top: auto;
                     margin-bottom: auto; margin-right: 12px"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Neues Raster
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0">
          <v-data-table
              dense
              :headers="headers"
              :items="azras"
              height="calc(100vh - 55px - 2.55rem - 4px)"
              hide-default-footer
              disable-pagination
              single-select
              item-key="bis_id"
              fixed-header
              ref="data_table"
              @click:row="onClick"
              no-data-text="Keine Daten vorhanden."
              sort-by="name"
          >
            <template v-slot:item.name="{ item }">
              <v-tooltip bottom  v-if="item.count_phases === 0" color="error">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      style="color: red; margin-right: 8px"
                      v-bind="attrs"
                      v-on="on"
                  >
                    mdi-alert-circle
                  </v-icon>
                </template>
                <span>Dieses Arbeitszeitraster muss importiert werden.</span>
              </v-tooltip>
              <span><b>{{item.name}}</b></span>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>

    <v-dialog
        v-model="createAzraDialog"
        scrollable
        max-width="300px"
    >
      <v-card>
        <v-card-title>Aus Vorlage erstellen ?</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 300px;">
          <v-radio-group
              v-model="selectedAzraId"
              column
              hide-details
          >
            <v-radio
                label="Ohne Vorlage"
                value=""
            ></v-radio>
            <v-radio v-for="azra in validAzras"
                :label="azra.name"
                :value="azra.id"
                     :key="azra.id"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="createAzraDialog = false"
          >
            Abbrechen
          </v-btn>
          <v-btn
              color="blue darken-1"
              text
              @click="createAzraDialog = false; openRaster('0', selectedAzraId)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "azra_list",
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Nummer',
          value: 'bis_id',
          sortable: true,
        },
        { text: 'Anzahl Phasen', value: 'count_phases'},
        { text: 'Anzahl Mitarbeiter', value: 'count_assigned_users',},
      ],
      azras: [],
      loader: undefined,
      createAzraDialog: false,
      selectedAzraId: "",
    }
  },
  mounted () {
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/basis_data/azra'
    ).then(this.responseOkGet, this.responseError)
  },
  computed: {
    validAzras() {
      return this.azras.filter(azra => azra.count_phases > 0).sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    openRaster(id, selectedAzraId = "") {
      this.$router.push("/basis/azra/"+id + (selectedAzraId !== "" ? "?template=" + selectedAzraId : ""));
    },
    onClick(item, elem) {
      this.openRaster(item.id);
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.azras = response.body;
      } else {
        window.location = Redirect_500;
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
  }

}
</script>

<style scoped>

::v-deep label {
  margin-bottom: initial;
}

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

</style>

